import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext'; // Assuming you're using AuthContext

const BlankPage = () => {
  const navigate = useNavigate();
  const location = useLocation(); // Get location to access state
  const { profile, profileLoading } = useAuth();

  // Retrieve blockedRole from location state
  const { blockedRole } = location.state || {};

  const [_unblockedRole, setUnblockedRole] = useState(null);

  useEffect(() => {
    // console.log('Profile:', profile); // Logging profile to ensure it's populated
    // console.log('Profile Loading:', profileLoading);

    if (!profileLoading && profile) {
      // Safe check if roles and blocked are defined
      if (profile?.role) {
        const unblockedRoles = profile?.role.filter(
          (role) => !profile?.blocked?.includes(role), // Safely check profile.blocked
        );
        // console.log('Unblocked Roles:', unblockedRoles); // Log unblocked roles for debugging

        if (unblockedRoles?.length > 0) {
          setUnblockedRole(unblockedRoles[0]); // Set the first unblocked role
        }
      } else {
        // console.log('Profile roles are not available or not an array.');
      }
    }
  }, [profile, profileLoading]);

  useEffect(() => {
    // console.log('BlockedRole:', blockedRole); // Debugging blockedRole

    if (!profileLoading && profile) {
      // Check if the user is blocked for the current role
      if (profile?.blocked && profile?.blocked.includes(blockedRole)) {
        Swal.fire({
          icon: 'error',
          title: 'Access Denied',
          text: 'You have been blocked by the admin. Please contact support.',
          confirmButtonText: 'Contact Admin',
          confirmButtonColor: '#dc3545',
        }).then((result) => {
          if (result.isConfirmed) {
            navigate('/contact-admin');
          }
        });
      } else {
        // Access is allowed - redirect to home
        navigate('/home');
      }
    }
  }, [profile, profileLoading, navigate, blockedRole]);

  return (
    <div className="blank-page" style={{ height: '100vh', width: '100%' }}>
      {/* Blank Page with no content */}
    </div>
  );
};

export default BlankPage;
